import formatDistanceStrict from 'date-fns/formatDistanceStrict';
// Polyfill of Intl.PluralRules that is currently not supported in Safari
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/es';

// Date-fns locales
import esDateFnsLocale from 'date-fns/locale/es';

// Locales json
const fnsLocales = {
	es: esDateFnsLocale,
};
// TODO: Replace this array with a query to the languages table when all languages
// declared in that table are supported
const supportedLanguages = ['en', 'es'];

export const getLanguageCode = language => {
	const rootLanguageCode = language.split('-')[0];
	const supportedLanguage = supportedLanguages.includes(rootLanguageCode)
		? rootLanguageCode
		: 'en';

	return supportedLanguage;
};

/**
 * Will take an array of objects intended to be used as options for a form, and
 * return a new array containing the same objects only replacing the value in the
 * property whose name is represented by the label parameter, with its localized value.
 *
 * @function
 * @param {array} options Array of objects
 * @param {object} messages I18n object to look up the localized value
 * @param {string} label The name of the property we want to localize
 * @returns {array}
 */
export const localizeFormOptions = (options, messages, label = 'label') =>
	options.map(option => ({
		...option,
		[label]: messages[option[label]] || option[label],
	}));

/**
 * Same as date-fns/formatDistanceStrict but it will also take a locale key to
 * translate the words according to the language selected.
 *
 * @function
 * @param {date} date1
 * @param {date} date2
 * @param {string} locale
 * @returns {string}
 */
export const localizedDistanceStrict = (date1, date2, locale) =>
	formatDistanceStrict(date1, date2, { locale: fnsLocales[locale] });
